<script setup lang="ts">
import { useRoute } from 'vue-router';

import { GHRoutes } from '@/router/routes';

import { useToastStore } from '@/stores/useToastStore';

import GToast from '@/common-components/GToast';

import GLayout from '@/components/GLayout';
import GActivityGhcc from '@/components/GActivityGhcc';

const route = useRoute();

const toastStore = useToastStore();
</script>

<template>
  <GLayout />
  <GActivityGhcc v-if="route.name !== GHRoutes.LearningActivityPage" />
  <GToast :toast="toastStore.toast" @close="toastStore.clearToast" />
</template>
